import { gql } from "lib/apolloClient";

export const getGradeScaleValuesQuery = gql`
  query getGradeScaleValues($id: ID!, $filters: GradingSetupEntityFilters) {
    node(id: $id, type: GRADE_SCALE) {
      id
      ... on GradeScale {
        id
        gradeScaleEntityDetails(filters: $filters) {
          id
          gradeScaleValues {
            id
            label
            abbreviation
            displaySequence
            type
            gradeScaleValueScores {
              id
              gradeValue
            }
          }
        }
      }
    }
  }
`;

export const getStandardGradeScaleDescriptorsQuery = gql`
  query getStandardGradeScaleDescriptors($ids: [ID!]) {
    multiNode(ids: $ids, type: PLANNER_ELEMENT_NODE) {
      id
      ... on PlannerElementNode {
        id
        standardsWrapper {
          standardGradeScaleValueDescriptor {
            id
            description
            gradeScaleValue {
              id
            }
          }
        }
      }
    }
  }
`;

// TODO: get support added for PLANNER_BENCHMARK in multiNode
export const getBenchmarkGradeScaleDescriptorsQuery = gql`
  query getBenchmarkGradeScaleDescriptors($ids: [ID!]) {
    multiNode(ids: $ids, type: PLANNER_BENCHMARK) {
      id
      ... on PlannerBenchmark {
        id
        standardsWrapper {
          standardGradeScaleValueDescriptor {
            id
            description
            gradeScaleValue {
              id
            }
          }
        }
      }
    }
  }
`;
